import { CALENDAR_EVENT_TYPES, CalendarDayEvents, CalendarEventType } from '../types';

const pad2 = (value: number): string => String(value).padStart(2, '0');

export const toIsoDate = (date: Date): string =>
  `${date.getFullYear()}-${pad2(date.getMonth() + 1)}-${pad2(date.getDate())}`;

export const addYears = (date: Date, years: number): Date => {
  const next = new Date(date.getTime());
  next.setFullYear(next.getFullYear() + years);
  return next;
};

export const getEventsCalendarRange = (
  today: Date = new Date()
): { readonly fromDate: string; readonly toDate: string } => ({
  fromDate: toIsoDate(addYears(today, -1)),
  toDate: toIsoDate(addYears(today, 1)),
});

export const toMonthIndex = (year: number, month: number): number => year * 12 + month;

export const fromMonthIndex = (index: number): { readonly year: number; readonly month: number } => ({
  year: Math.floor(index / 12),
  month: index % 12,
});

export const getCalendarMonthBounds = (
  today: Date = new Date()
): { readonly minIndex: number; readonly maxIndex: number; readonly currentIndex: number } => {
  const currentIndex = toMonthIndex(today.getFullYear(), today.getMonth());
  return {
    minIndex: currentIndex - 12,
    maxIndex: currentIndex + 12,
    currentIndex,
  };
};

export const groupCalendarDays = (
  days: readonly CalendarDayEvents[]
): ReadonlyMap<string, CalendarDayEvents> => {
  const byDate = new Map<string, CalendarDayEvents>();
  for (const day of days) {
    byDate.set(day.date, day);
  }
  return byDate;
};

export const isCalendarEventType = (value: string): value is CalendarEventType =>
  (CALENDAR_EVENT_TYPES as readonly string[]).includes(value);
